import React from 'react';
import './Pill.css';

interface Props {
  active?: boolean;
  count?: number;
  onClick?: () => void;
  children: React.ReactNode;
}

export function Pill({ active = false, count, onClick, children }: Props) {
  return (
    <button
      type="button"
      className={`staff-pill ${active ? 'active' : ''}`}
      onClick={onClick}
    >
      <span>{children}</span>
      {count != null && <span className="staff-pill-count">{count}</span>}
    </button>
  );
}
